
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M94.6 2.4C93 .8 91.2 0 89 0c-2.2 0-4 .8-5.6 2.4l-56 56C25.8 60 25 61.8 25 64c0 2.2.8 4 2.4 5.6l56 56c1.6 1.6 3.5 2.4 5.6 2.4 2.2 0 4-.8 5.6-2.4 1.6-1.6 2.4-3.5 2.4-5.6V8c0-2.2-.8-4-2.4-5.6z"}})])
          )
        }
      }
    